// api
import { fetchApi } from '@/api'
// actions
const papeleriaDeliveriesAll = (context) => {
  let url = 'papeleria/deliveries'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_DELIVERIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaDeliveriesForm = (context) => {
  let url = 'papeleria/deliveries/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_DELIVERIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaDeliveriesShow = (context) => {
  let url = 'papeleria/deliveries'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_DELIVERIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const papeleriaDeliveriesCreate = (context) => {
  let url = 'papeleria/deliveries/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_DELIVERIES_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaDeliveriesUpdate = (context) => {
  let url = 'papeleria/deliveries'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_DELIVERIES_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaDeliveriesDelete = (context, payload) => {
  let url = 'papeleria/deliveries'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_DELIVERIES_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  papeleriaDeliveriesAll,
  papeleriaDeliveriesForm,
  papeleriaDeliveriesShow,
  papeleriaDeliveriesCreate,
  papeleriaDeliveriesUpdate,
  papeleriaDeliveriesDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/deliveries/actions.js